<template>
  <div class="empty-state">
    <div class="empty-content">
      <!-- 图标容器 -->
      <div class="icon-wrapper">
        <slot name="icon">
          <!-- 默认搜索图标 -->
          <img style="width: 100%;height: 100%;" :src="iconDef">
        </slot>
      </div>

      <!-- 主标题 -->
      <div class="empty-title">
        <slot name="title">{{ title }}</slot>
      </div>

      <!-- 描述文字 -->
      <div class="empty-description" v-if="description || $slots.description">
        <slot name="description">{{ description }}</slot>
      </div>

      <!-- 操作按钮 -->
      <div class="empty-actions" v-if="$slots.actions">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import noData from '@/assets/images/empty.svg'
import noSearch from '@/assets/images/search.svg'
import noMessage from '@/assets/images/no-message.png'
import {computed} from 'vue';
interface Props {
  // 标题文字
  title?: string;
  // 描述文字
  description?: string;
  icon?: string;
  type?: string;
}
interface Images {
  [key: string]: string
}
const props = withDefaults(defineProps<Props>(), {
  type: 'empty',
  title: '查询无结果',
});
const defIconUrl: Images = {
  empty: noData,
  search: noSearch,
  noMessage: noMessage,
}
const iconDef = computed(() => {
  if (defIconUrl[props.type]) {
    return defIconUrl[props.type]
  } else {
    return props.icon
  }
})
</script>

<style scoped lang="scss">
.empty-state {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  box-sizing: border-box;
  min-height: 300px;

  .empty-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    max-width: 400px;
  }

  .icon-wrapper {
    margin-bottom: 20px;
    width: 142px;
    height: 121px;

    
  }

  .empty-title {
    font-size: 16px;
    font-weight: 400;
    color: #C9D3D9;
    line-height: 24px;
    margin-bottom: 10px;
  }

  .empty-description {
    font-size: 12px;
    color: #C9D3D9;
    line-height: 22px;
    margin-bottom: 0;
  }

  .empty-actions {
    margin-top: 24px;
    display: flex;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
  }
}
</style>
